import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { credentialsInterceptor } from '@core/interceptors/credentials.interceptor';
import { DiagnosticsErrorHandler } from '@core/diagnostics/diagnostics-error-handler';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([credentialsInterceptor])),
    provideRouter(routes),
    { provide: ErrorHandler, useClass: DiagnosticsErrorHandler }
  ]
};
